import { useMachine } from '@xstate/react'
import { ReadProps } from 'api/read'
import {
  RequestMachineContext,
  RequestMachineEventData,
  RequestMachineStates,
  requestMachine,
} from 'machines/requestMachine'
import { useUsersActions } from 'providers'
import { useCallback } from 'react'
import { State } from 'xstate'

/**
 * Reads the user from the DB, returns [the FULL user or undefined, the current read machine state object]
 * @param initID the ID the readMachine should be queued up to read
 * */
export const useRead = (): [
  (id: ReadProps['id']) => void,
  State<RequestMachineContext, RequestMachineEventData, RequestMachineStates>
] => {
  const [state, send] = useMachine(requestMachine)
  const { read: readUser } = useUsersActions()

  const read = useCallback(
    (id: ReadProps['id']) => {
      const promise = readUser({ id })
      send('SET_PROMISE', { data: promise })
    },
    [send, readUser]
  )
  return [read, state]
}
